<div class="warehouse-group__wrapper p-5">
  <div class="flex align-center">
    <div class="grow">
      <h3 class="m-0">Warehouse Groups</h3>
    </div>
    <!-- TODO: Obsolete don't follow -->
    <lum-ui-button
      label="Create Warehouse Group"
      size="medium"
      type="secondary"
      (click)="onOpenDialog()"
    >
    </lum-ui-button>
  </div>

  <lum-location-warehouse-group-filter
    (filterUpdateEvent)="onUpdateFilters($event)"
  ></lum-location-warehouse-group-filter>

  <div class="py-5">
    <lum-location-warehouse-group-table
      (openDialog)="onOpenDialog($event)"
      (deleteEvent)="onDelete($event)"
      [ftPickAndPackEnabled]="ftPickAndPackEnabled"
      [data]="(warehouseGroups$ | async) || []"
      [loading]="(loading$ | async) || false"
    ></lum-location-warehouse-group-table>
  </div>
  <mat-paginator
    [length]="(pagination$ | async)?.total"
    [pageSize]="(pagination$ | async)?.per_page"
    [pageSizeOptions]="paginationConfig.pageSizeOptions"
    [pageIndex]="((pagination$ | async)?.current_page || 1) - 1"
    (page)="onPaginationEvent($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</div>
